<template>
  <div>
    <obk-description-partner-note-step step-number="1" />
    <obk-description-no-incognito-step step-number="2" />
    <obk-description-no-ad-blocker-step step-number="3" />
  </div>
</template>

<script>
import ObkDescriptionPartnerNoteStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionPartnerNoteStep';
import ObkDescriptionNoIncognitoStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionNoIncognitoStep.vue';
import ObkDescriptionNoAdBlockerStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionNoAdBlockerStep.vue';

export default {
  name: 'OpenBankingBankDescription',
  components: { ObkDescriptionNoAdBlockerStep, ObkDescriptionNoIncognitoStep, ObkDescriptionPartnerNoteStep },
};
</script>

<style scoped lang="scss">

</style>
